import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'checkliste';
  currentStep: number = 1;
  isCompleted: boolean = false;
  formdata: any = FormGroup;
  appHasPassed: boolean = true;
  rating: number = 0.0;
  conclusion: string = '';

  wizard1 = {
    choices: [
      { 
        weight: 5, 
        name: '<p>Elle décrit un domaine d’application concret ; par exemple, la prise quotidienne de médicaments.</p>',
        text: { title: 'But et fonctionnalité', description: 'Indépendamment des exigences individuelles, l’appli devrait globalement répondre aux critères suivants pour fonctionner en toute sécurité et stabilité :'}
      },
      { 
        weight: 5, 
        name: 'Les limites de l’appli sont clairement mentionnées (par exemple, son utilisation ne saurait remplacer une consultation médicale).'
      },
      { 
        weight: 2.5, 
        name: 'Sa dernière mise à jour remonte à six mois au plus (valeur indicative). ',
      },
      { 
        weight: 2.5, 
        name: 'Le fonctionnement est stable et sans interruption ou redémarrage.',
      },
      {  
        weight: 10, 
        name: 'L’appli n’émet pas de diagnostic définitif ni de recommandations de traitement.',
        text: {title: 'Applis de diagnostic et de traitement', description: 'Assurez-vous que les deux points suivants soient satisfaits dans tous les cas :'}
      },
      {  
        weight: 5, 
        name: 'L’appli contribue à la thérapie (par exemple saisie de valeurs).' 
      },
      {  
        weight: 2.5, 
        name: 'L’appli a reçu un grand nombre d’évaluations positives par divers utilisateurs.',
        text: { title: 'Evaluation par d’autres utilisateurs', description: ''}
      }
    ]
  };

  wizard2 = {
    choices: [
      { 
        weight: 5, 
        name: 'L’appli est certifiée et dispose d’un label fiable.',
        text: { title: 'Label ou authentification', description: ''}
      },
      {  
        weight: 2.5, 
        name: 'Les critères d’évaluation du label sont compréhensibles et pertinents.'
      },
      { 
        weight: 5,
        ko_criteria: 1, 
        is_parent: 1,
        name: 'L’appli comprend une déclaration de protection des données qui...',
        text: { title: 'Déclaration de protection des données', description: 'Toute appli devrait comporter une déclaration de protection des données répondant aux critères suivants :'}
      },
      { 
        weight: 5, 
        is_sub: 1,
        name: 'est aisément disponible (par exemple directement sur l’appli, le site Internet ou le store du fournisseur concerné) ;',
      },
      { 
        weight: 5, 
        is_sub: 1,
        name: 'fournit des informations sur le type, la portée et l’objectif de la collecte et de l’utilisation des données ainsi que sur la transmission éventuelle à des tiers ;' 
      },
      { 
        weight: 5, 
        is_sub: 1,
        name: 'spécifie dans quel pays et de quelle manière (cryptée/anonymisée) les données sont stockées ;',
      },
      { 
        weight: 5, 
        is_sub: 1,
        name: 'vous informe par quel biais (e-mail, courrier, etc.) vous pouvez vous opposer à l’enregistrement de vos données.' 
      },
      { 
        weight: 5, 
        name: 'L’appli ne demande que les données personnelles nécessaires à la fonctionnalité.',
        text: { title: 'But et fonctionnalité', description: 'Les applis qui demandent ou enregistrent vos données personnelles devraient répondre aux critères suivants :'}
      },
      { 
        weight: 5, 
        name: 'Les droits d’accès aux fonctionnalités des appareils mobiles (par exemple autorisation de géolocalisation par GPS ou accès au calendrier) ne sont demandés que s’ils sont nécessaires à l’utilisation de l’appli.' 
      },
      { 
        weight: 5, 
        name: 'Il est possible de supprimer les données saisies et enregistrées. Une suppression complète des données stockées n’est généralement pas possible. Réfléchissez donc bien à quelles données vous divulguez.' 
      }
    ]
  };

  wizard3 = {
    choices: [
      { 
        weight: 5, 
        ko_criteria: 1,
        name: 'Nom et adresse du fournisseur. Particularité pour les personnes morales (par exemple Sàrl ou SA) : indication de la forme juridique et des représentants légitimes.',
        text: { title: 'Impressum', description: 'L’impressum d’une appli doit au moins comprendre les éléments suivants :'},
      },
      { 
        weight: 5, 
        name: 'Indications permettant un contact direct et immédiat (numéro de téléphone ou de fax, adresse e-mail).',
      },
      { 
        weight: 5, 
        name: 'L’appli fait preuve de transparence financière, par exemple : <br><br> • Elle est autofinancée et payante. <br><br> • Ses coûts sont pris en charge par les assurances maladie (très rare). <br><br> • L’appli est financée par des sponsors ou des donateurs.<br><br>',
        text: { title: 'Transparence et financement', description: ''}, 
      },
      { 
        weight: 5, 
        name: 'L’appli est neutre, ses contenus ne sont donc pas influencés par des intérêts commerciaux, par exemple : <br><br> • Elle ne vante pas les avantages d’un produit spécifique. <br><br> • Elle est gérée par un organisme public ou d’intérêt général.',
      }
    ]
  };


  constructor(private formsModule: FormsModule, private formBuilder: FormBuilder) {
    this.formdata = this.formBuilder.group({
      wizard1_choices: new FormArray([]),
      wizard2_choices: new FormArray([]),
      wizard3_choices: new FormArray([])
    });

    this.addCheckboxes();
  }

  private addCheckboxes() {
    this.wizard1.choices.map((o, i) => {
      const control = new FormControl(false); // checked = false
      (this.formdata.controls.wizard1_choices as FormArray).push(control);
    });

    this.wizard2.choices.map((o, i) => {
      const control = new FormControl(false); // checked = false
      (this.formdata.controls.wizard2_choices as FormArray).push(control);
    });

    this.wizard3.choices.map((o, i) => {
      const control = new FormControl(false); // checked = false
      (this.formdata.controls.wizard3_choices as FormArray).push(control);
    });
  }

  onCheckboxChange(checkbox, checked) {
    this.formdata.controls.wizard2_choices.value.forEach((value, index) => {
      if(checkbox.hasOwnProperty('is_parent') && this.wizard2.choices[index].hasOwnProperty('is_sub')) {
        if(!checked) {
          this.formdata.controls.wizard2_choices.controls[index].setValue(false);
        }
      } else if(checkbox.hasOwnProperty('is_sub') && this.wizard2.choices[index].hasOwnProperty('is_parent')) {
        if(checked) {
          this.formdata.controls.wizard2_choices.controls[index].setValue({value: true});
        }
      }
    });
  }

  onStep1Next() {
    this.currentStep = 2;
    window.top.scroll(0,0);
    window.scroll(0,0);
  }

  onStep2Next() {
    this.currentStep = 3;
    window.top.scroll(0,0);
    window.scroll(0,0);
  }

  onStep3Next() {
    this.currentStep = 3;
    window.top.scroll(0,0);
    window.scroll(0,0);
  }

  onComplete() {
      window.top.scroll(0,0);
      window.scroll(0,0);
     this.isCompleted = true;

     this.formdata.controls.wizard1_choices.value.forEach((choice, index) => {
       if(this.wizard1.choices[index].hasOwnProperty('ko_criteria') && !choice) {
         this.appHasPassed = false;
       } else if(choice) {
         this.rating += this.wizard1.choices[index].weight;
       }
     });

     this.formdata.controls.wizard2_choices.value.forEach((choice, index) => {
       if(this.wizard2.choices[index].hasOwnProperty('ko_criteria') && !choice) {
         this.appHasPassed = false;
       } else if(choice) {
         this.rating += this.wizard2.choices[index].weight;
       }
     });

     this.formdata.controls.wizard3_choices.value.forEach((choice, index) => {
       if(this.wizard3.choices[index].hasOwnProperty('ko_criteria') && !choice) {
         this.appHasPassed = false;
       } else if(choice) {
         this.rating += this.wizard3.choices[index].weight;
       }
     });

     if(this.appHasPassed && this.rating >= 0 && this.rating <= 40) {
       this.conclusion = "L’appli ne répond qu’à un petit nombre des critères recommandés pour les applis santé. Si vous choisissez d’y recourir malgré tout, ayez conscience des risques.";
     } else if(this.appHasPassed && this.rating > 40 && this.rating <= 84) {
       this.conclusion = "L’appli répond à un grand nombre des critères recommandés, mais pas à tous. C’est à vous de décider si cette proportion est suffisante.";
     } else if(this.appHasPassed && this.rating > 84 && this.rating <= 99) {
       this.conclusion = "L’appli répond à (presque) tous les critères recommandés par l’alliance de sécurité allemande des patients (Aktionsbündnis Patientensicherheit e.V.).";
     } else if(this.appHasPassed && this.rating > 99) {
       this.conclusion = "L’appli répond à tous les critères recommandés par l’alliance de sécurité allemande des patients (Aktionsbündnis Patientensicherheit e.V.).";
     } else if(!this.appHasPassed) {
       this.conclusion = "L’appli vérifiée ne comporte pas de déclaration de protection des données et/ou pas d’impressum. Nous déconseillons donc de l’utiliser.";
     }
  }

  exit() {
    window.top.location.href = 'https://www.aps-ev.de/'; //window.top.location.origin
  }

  reload() {
    window.location.reload();
    window.top.scroll(0,0);
    window.scroll(0,0);
  }
}
